/**
 * Copyright © 2026 Delicious AI, LLC
 */

export const Colors = {
  PRIMARY: '#e2000f',
  PRIMARY_600: '#c2000d',
  SECONDARY: '#1e2a38',
  WHITE: '#ffffff',
  BLACK: '#000000',
  BLUE_5: '#2f65cb',
  DARK_GRAY: '#2b2b2b',
}
